module.exports = __webpack_public_path__ + "static/media/pg_sample_right_beaker.d45d4a3e.svg";